<footer>
    <div class="copyright / has-text-warning">
        Copyright 2024 Stop Watch
    </div>
</footer>

<style>
    footer {
        padding: 90px;
        text-align: center;
    }

    .copyright {
        font-size: 14px;
        display: inline-block;
        padding: 20px;
        border-top: 1px solid #f1a210;
    }
</style>